import { MapManager } from './modules/curvature.js';
import * as $ from 'jquery';

jQuery(document).ready(function ($) {
  window.mapManager = new MapManager($);
});

// Add our WordPress nirvana theme asset.
require('./nirvana-frontend.js');
